import script from "./sellerTable.vue?vue&type=script&lang=jsx&setup=true"
export * from "./sellerTable.vue?vue&type=script&lang=jsx&setup=true"

import "./sellerTable.vue?vue&type=style&index=0&id=707ceb85&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-707ceb85"]])

export default __exports__